







































import { getConfig, updateConfig } from '../gameConfig'
import { Vue, Component, Watch } from 'vue-property-decorator'

@Component
export default class Division extends Vue {
	config = {
		numbers: [100, 10],
		type: 'divide',
	}

	startGame() {
		this.$store.commit('changeGameConfig', this.config)
		this.$router.push({ path: '/games/game' })
	}

	get isCustomBgEnabled() {
		return !!this.$store.getters.primaryBackground
	}
	get complexity1List() {
		return [1000, 100, 10]
	}

	get complexity2List() {
		return [100, 10, 1]
	}

	@Watch('config', { deep: true })
	onConfigChanged(val: any) {
		updateConfig({ division: () => val })
	}

	created() {
		// Setup default values
		const config = getConfig()
		this.config = config.division as any
	}
}
